import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getMoviesByType } from '@/utils/movie';

const accents = ['bg-primary-500', 'bg-accent-500', 'bg-secondary-500'];

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
      {categories.map((c, i) => {
        const color = accents[i % accents.length];
        return (
          <Link
            key={c.key}
            to={`/category/${c.key}`}
            className="group relative overflow-hidden rounded-lg border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-primary-300 cursor-pointer md:p-5"
          >
            <span
              className={`flex h-11 w-11 items-center justify-center rounded-lg text-white ${color}`}
            >
              <i className={`${c.icon} text-xl`}></i>
            </span>
            <h3 className="mt-3 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
              {c.name}电影
            </h3>
            <p className="mt-1 text-xs text-foreground-500">
              共 {getMoviesByType(c.key).length} 部影片
            </p>
            <i className="ri-arrow-right-up-line absolute right-4 top-4 text-xl text-foreground-300 transition-colors group-hover:text-accent-500"></i>
          </Link>
        );
      })}
    </div>
  );
}